<template>
  <div>
    <div class="search-bar">
      <span>Manage the customers orders here</span>
      <a-input placeholder="Search...">
        <template slot="prefix">
          <a-icon type="search" />
        </template>
      </a-input>
    </div>
    <a-row>
      <a-col :span="18" :md="12" :lg="15" :xxl="18">
        <a-tabs type="card">
          <template v-for="(c, index) in categories">
            <a-tab-pane :key="c.categoryId" :tab="c.categoryName">
              <a-row :gutter="[16, 16]">
                <template v-for="i in productsByCategoryId(c.categoryId)">
                  <a-col :md="2" :lg="8" :xxl="6">
                    <product-card
                      :productId="i.itemId"
                      :productName="i.itemName"
                      :productPrice="i.originalPrice"
                      :productTax="i.taxValue"
                      :productCategory="i.category"
                      :productImage="i.imageUrl"
                      :productDescription="i.description"
                      :productOptions="i.options"
                      :productAllergyIcons="i.allergiesJSON"
                      :estimatedTime="i.estimatedTime"
                      :isOutOfStock="i.isOutOfStock"
                      @productAddedToCart="handleAddToCartEvent($event)"
                    />
                  </a-col>
                </template>
              </a-row>
            </a-tab-pane>
          </template>
        </a-tabs>
      </a-col>

      <a-col class="sidebar-cart" :span="4" :lg="8" :xxl="5" :gutter="8">
        <h2>Current Order</h2>
        <div v-for="(item, index) in cart" :key="index">
          <product-list-item
            class="animate__animated animate__rollIn"
            :productName="item.itemName"
            :productCategory="item.categoryName"
            :productImage="item.imageUrl"
            :productPrice="item.itemPrice"
          />
        </div>
        <div class="price-card">
          <div class="price-content">
            <div class="subtotal"><span>Subtotal</span><span> 55 kr</span></div>
            <div class="vat"><span>VAT</span><span> 55 kr</span></div>
            <div class="discount"><span>Discount</span><span> 55 kr</span></div>
            <div class="total"><span> Total</span><span> 55 kr</span></div>
          </div>
        </div>
        <button class="payment-btn">Continue to Payment</button>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import ProductCard from '../../components/cards/ProductCard.vue';
import ProductListItem from '../../components/cards/ProductListItem.vue';
import 'animate.css';
export default {
  inject: ['eventBus'],

  components: {
    ProductCard,
    ProductListItem,
  },

  components : {
    ProductCard,
    ProductListItem
  },
    
    computed : {
        ...mapState({
            products : state => state.pos.products,
            currentWaitingTime : state => state.pos.orderManager.currentWaitingTime,
            cart : state => state.pos.cart
        }),
        ...mapGetters({ 
            productsByCategoryId : 'pos/productsByCategoryId',
            categories : 'pos/categoriesFromProductsList',
            totalItems : 'ordering/totalItems',
            amount : 'ordering/amount'
        }),
    },

  data() {
    return {};
  },

  methods: {
    ...mapMutations({
      handleAddToCartEvent: 'pos/ADD_TO_CART_STATE',
    }),
  },
  async created() {
    await this.$store.dispatch('pos/getProductsAction', {});
    await this.$store.dispatch('pos/getCategoriesAction', {});
    await this.$store.dispatch('pos/getTaxesAction', {});
  },
  destroyed() {},
};
</script>

<style lang="scss" scoped>
.payment-btn {
  background: white;
  color: black;
  border-radius: 5px;
  width: 100%;
  margin-top: 10px;
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande',
    'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
  font-size: 20px;
  font-weight: bold;
  padding: 12px;
  outline: none;
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
  border: 0;
  cursor: pointer;
}
.payment-btn:hover {
  background: darkred;
  transition: all 0.3s;
  color: white;
}
.price-content {
  padding: 10px;
  font-weight: bold;
}

.price-content > div {
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
}
.discount {
  border-bottom: 1px dashed;
  padding-bottom: 5px;
}

.total {
  margin-top: 10px;
}
.price-card {
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
  border-radius: 10px;

  margin-top: 2rem;
}
.sidebar-cart {
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
  border-radius: 10px;
  padding: 1rem;
  margin-left: 2.5rem;
  @media (max-width: 1280px) {
    margin-left: 1.8rem;
  }
}

.search-bar {
  display: flex;
  justify-content: space-between;
}
.ant-input-affix-wrapper {
  width: 14rem;
  margin-right: 24.3rem;
  margin-bottom: 10px;

  @media (max-width: 1280px) {
    margin-right: 23.5rem;
  }
}
</style>
